import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { GSPMetadataService } from '@gsp-lcm/metadata-selector';
import { CommonEntityVO } from '../entity/common-entity-vo';
import { CommonEntityService } from './common-entity-service';


@Injectable()
export class InternalCommonEntityService {
    currentProjectPath: string;
    rootPath: string;
    packRefPath: string;
    constructor(private gspMetadataService: GSPMetadataService, private ceService: CommonEntityService) {
        this.packRefPath = '/packages';
    }

    //æ¯æçåæ°æ®åç¼
    postfix = ".be,.vo";

    //mockæ èç¹æ°æ®
    treeData: any[];
    //ç¼å­çåæ°æ®
    metadatas = [];
    //ç¼å­çå
    packages = [];

    //å¢å åæ°æ®ï¼åç¼å­ä¸­ï¼
    addMetadata(metadata) {
        this.metadatas.push(metadata);
    }

    addPackage(mp) {
        this.packages.push(mp);
    }

    //æ¸ç©ºåæ°æ®ç¼å­
    clearMetadata() {
        this.metadatas = [];
    }
    clearPackage() {
        this.packages = [];
    }

    //è·åå½åå·¥ç¨ä¸ææçåæ°æ®(æ´ä¸ªåè¡¨ééä¸ºce)
    getCEList(typeList: string): Observable<any> {
        // return this.gspMetadataService.GetMetadataList(this.currentProjectPath, typeList);
        return this.ceService.getCEList(this.currentProjectPath, typeList);
    }

    //è·ååæ°æ®åä¸­æåå«çåæ°æ®ä¿¡æ¯ï¼è½¬æCeä»¥åçï¼
    getCEListByMetadataPkg(packPath: string, packageName: string): Observable<any> {
        let fullName = '';
        if (packageName.endsWith('mdpkg')) {
            fullName = packageName;
        } else {
            fullName = packageName + '.mdpkg';
        }
        return this.ceService.getCEListByMetadataPkg(packPath, fullName);
        // return this.gspMetadataService.GetMetadataPackageInfo(packPath, fullName);
    }

    //è·åå½åå·¥ç¨ä¸çceå¤´ä¿¡æ¯
    getCEHeaderInfo(): CommonEntityVO {
        if (this.metadatas.length > 0) {
            const index1 = this.metadatas.length;
            if (index1 > 0) {
                const index2 = this.metadatas[index1 - 1].treenode.MetadataInfo.length;
                if (index2 > 0) {
                    return this.metadatas[index1 - 1].treenode.MetadataInfo[index2 - 1] as CommonEntityVO ;
                }
            } else {
                return new CommonEntityVO();
            }
        }
    }

    // è·ååæ°æ®åä¸­çceå¤´ä¿¡æ¯
    getCEHeaderFromPkg(): CommonEntityVO {
        const index1 = this.metadatas.length;
        if (index1 > 0) {
            const index2 = this.metadatas[index1 - 1].treenode.MetadataInfo.length;
            if (index2 > 0) {
                const packageName = this.metadatas[index1 - 1].treenode.PackageName;
                const packagePath = this.metadatas[index1 - 1].treenode.Location;
                let ceHeader:CommonEntityVO=this.metadatas[index1 - 1].treenode.MetadataInfo[index2 - 1] as CommonEntityVO;
                //ææå¨åæ°æ®åçä¿¡æ¯ä¹æ¿æ¢
                ceHeader.local=false;
                ceHeader.packageName=packageName;
                ceHeader.packagePath=packagePath;
                return ceHeader;
            }
        } else {
            return new CommonEntityVO;
        }
    }

    //å·¦ä¾§å¯¼èªæ ï¼ è·ååæ°æ®å·¥ç¨ä¿¡æ¯ï¼è·åæ¬å·¥ç¨ä¾èµçåæ°æ®ååºæ¬ä¿¡æ¯ï¼
    GetMetadataProjectInfo(): Observable<any> {
        return this.gspMetadataService.GetProjectInfo(this.currentProjectPath);
    }

    //å·¦ä¾§å¯¼èªæ ï¼è·åå·¥ç¨è·¯å¾
    GetMetadataProjPath(metadataPath: string): Observable<any> {
        return this.gspMetadataService.GetProjectInfo(metadataPath);
    }

    //å·¦ä¾§å¯¼èªæ ï¼è·åæ çåç±»æ°æ®
    getMetadataClassifier() {
        return classifier;
    }
}

// mockæ°æ®
const classifier: any[] = [
    { id: 'default', text: 'å½åå·¥ç¨' },
    { id: 'refs', text: 'å¼ç¨çåæ°æ®å', items: [] },
    { id: 'local', text: 'æ¬å°åæ°æ®å', items: [] }
];
